const SKIN_COLORS = {
  light: "light",
  medium: "medium",
  dark: "dark",
};

Object.freeze(SKIN_COLORS);

const PACK_STATUSES = {
  DRAFT: "draft",
  QUEUED_PREVIEW: "queued-preview",
  GENERATING_PREVIEW: "generating-preview",
  PREVIEW: "preview",
  QUEUED_STANDARD: "queued-standard",
  GENERATING_STANDARD: "generating-standard",
  LIVE: "live",
  DELETED: "deleted",
};

Object.freeze(PACK_STATUSES);

export { SKIN_COLORS, PACK_STATUSES };
